import useSWR from 'swr';

/**
 * Hook for fetching InteractiveActivity data by ID.
 *
 * Used by frontend components to load interactive content for rendering.
 * Only handles data fetching - does not include submission logic.
 */

interface InteractiveActivity {
  id: string;
  name: string;
  html_blob: string;
  s3_url?: string | null;
  metadata: Record<string, any>;
  content_source: 's3_url' | 'html_blob';
  created_at: string;
  updated_at: string;
}

interface UseInteractiveActivityReturn {
  data: InteractiveActivity | undefined;
  error: any;
  isLoading: boolean;
}

export const useInteractiveActivity = (
  activityId: string | null | undefined
): UseInteractiveActivityReturn => {
  // Only fetch if we have a valid activityId
  const shouldFetch = Boolean(activityId);
  const url = shouldFetch
    ? `/api/v1/interactive-activities/${activityId}/`
    : null;

  const { data, error, isLoading } = useSWR<InteractiveActivity>(url);

  return {
    data,
    error,
    isLoading: isLoading && shouldFetch, // Only show loading if we're actually fetching
  };
};
